module.exports = __webpack_public_path__ + "static/frog-14feefe14b9f337e8a87353d1805e6dc.jpeg";